import React, { useEffect, useState } from "react";
import { useError } from "../../Contexts/ErrorContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import "../../css/Common/ErrorPopup.css";

const ErrorPopup = () => {
  const { error, clearError } = useError();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (error) {
      setVisible(true);
      // const timeout = setTimeout(() => handleClose(), 5000);
      // return () => clearTimeout(timeout);
    }
  }, [error]);

  const handleClose = () => {
    setVisible(false);
    clearError();
  };

  if (!error || !visible) return null;

  return (
    <div className="toast-error" onClick={handleClose}>
      <div className="toast-icon">
        <FontAwesomeIcon icon={faExclamationCircle} />
      </div>
      <div className="toast-message">{error}</div>
    </div>
  );
};

export default ErrorPopup;
